import { sanitize, Config } from 'dompurify';

import { GetDisclosuresResponseType, ServerResponseType } from './types';

export const transformDisclosuresResponse = (
  response: ServerResponseType
): GetDisclosuresResponseType => {
  return {
    completed: response.completed,
    bodyTextSanitized: {
      __html: sanitize(response.bodyText),
    },
    dueDate: response.dueDate,
  };
};

export const transformDisclosuresResponseWithConfig = (
  response: ServerResponseType,
  config: Config
): GetDisclosuresResponseType => {
  return {
    completed: response.completed,
    bodyTextSanitized: {
      __html: sanitize(response.bodyText, config) as string,
    },
    dueDate: response.dueDate,
  };
};
